import service from "@/api/service";
import { PointBalanceUserCSVGetRequest } from "@/api/analysis/point-balance-user-csv/request";
import { DownloadCSVResponse } from "@/api/response";

/**
 * ポイント残高別ユーザーCSV出力APIをコールします。
 *
 * @param getRequest ポイント付与数・利用金額ユーザーCSV出力APIのリクエストボディ
 * @return response
 */
export async function get(getRequest: PointBalanceUserCSVGetRequest) {
  const response = await service.postReceiveCSV(
    "/analysis-point-balance-user-csv",
    getRequest
  );
  return response as DownloadCSVResponse;
}
